import {
    DEVICES_IMPORT_OPEN_MODAL,
    DEVICES_IMPORT_CLOSE_MODAL,

    DEVICES_IMPORT_PROCESS_CSV,
    DEVICES_IMPORT_PROCESS_CSV_RESULT,

    DEVICES_IMPORT_PROCESS_CALAMP_CSV,
    DEVICES_IMPORT_PROCESS_CALAMP_CSV_RESULT,

    DEVICES_IMPORT_PROCESS_PUI_CSV,
    DEVICES_IMPORT_PROCESS_QUECLINK_CSV,
    DEVICES_IMPORT_PROCESS_QUECLINK_CSV_RESULT,
    DEVICES_IMPORT_PROCESS_TELITEK_CSV,

    DEVICES_IMPORT_GET_DEVICE_MODEL,
    DEVICES_IMPORT_GET_DEVICE_MODEL_RESULT,

    DEVICES_IMPORT_LOAD_PHONE_NUMBERS,
    DEVICES_IMPORT_LOAD_PHONE_NUMBERS_RESULT,

    DEVICES_IMPORT_SAVE,
    DEVICES_IMPORT_SAVE_RESULT,

    DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO,
    DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO_RESULT,

    DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO,
    DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO_RESULT,
    DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV,
    DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV_RESULT,
    DEVICES_IMPORT_PROCESS_CEREBRUMX_CSV,
    DEVICES_IMPORT_PROCESS_PACIFIC_TRACK_CSV,
    DEVICES_IMPORT_PROCESS_ZONAR_CSV,
    DEVICES_IMPORT_PROCESS_GENX_CSV,
    DEVICES_IMPORT_PROCESS_DIGITAL_MATTERS_CSV,
    DEVICES_IMPORT_PROCESS_LIGHTMETRICS_CSV,
    DEVICES_IMPORT_PROCESS_M2MD_CSV,
    DEVICES_IMPORT_PROCESS_SMARTWITNESS_CSV,

    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    fileResponse: null,
    deviceModel: null,
    devicesPhones: null,
    importResult: null,
    calampDevices: null,
    geometrisDevices: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case DEVICES_IMPORT_OPEN_MODAL:
            return { ...state, openModal: true }

        case DEVICES_IMPORT_CLOSE_MODAL:
            return { ...state, openModal: false }


        case DEVICES_IMPORT_PROCESS_CSV:
        case DEVICES_IMPORT_PROCESS_PUI_CSV:
        case DEVICES_IMPORT_PROCESS_QUECLINK_CSV:
        case DEVICES_IMPORT_PROCESS_CEREBRUMX_CSV:
        case DEVICES_IMPORT_PROCESS_TELITEK_CSV:
        case DEVICES_IMPORT_PROCESS_PACIFIC_TRACK_CSV:
        case DEVICES_IMPORT_PROCESS_ZONAR_CSV:
        case DEVICES_IMPORT_PROCESS_GENX_CSV:
        case DEVICES_IMPORT_PROCESS_DIGITAL_MATTERS_CSV:
        case DEVICES_IMPORT_PROCESS_LIGHTMETRICS_CSV:
        case DEVICES_IMPORT_PROCESS_M2MD_CSV:
        case DEVICES_IMPORT_PROCESS_SMARTWITNESS_CSV:
            return { ...state, internalLoading: true, fileResponse: null };

        case DEVICES_IMPORT_PROCESS_CSV_RESULT:
        case DEVICES_IMPORT_PROCESS_QUECLINK_CSV_RESULT:
            return { ...state, internalLoading: false, fileResponse: action.payload };

        case DEVICES_IMPORT_PROCESS_CALAMP_CSV:
            return { ...state, loading: true, fileResponse: null };

        case DEVICES_IMPORT_PROCESS_CALAMP_CSV_RESULT:
            return { ...state, loading: false, fileResponse: action.payload, };

        case DEVICES_IMPORT_GET_DEVICE_MODEL:
            return { ...state, loading: true, deviceModel: null };

        case DEVICES_IMPORT_GET_DEVICE_MODEL_RESULT:
            return { ...state, loading: false, deviceModel: action.payload, };

        case DEVICES_IMPORT_LOAD_PHONE_NUMBERS:
            return { ...state, devicesPhones: null, loading: true };

        case DEVICES_IMPORT_LOAD_PHONE_NUMBERS_RESULT:
            return { ...state, devicesPhones: action.payload, loading: false };

        case DEVICES_IMPORT_SAVE:
            return { ...state, loading: true, importResult: null };

        case DEVICES_IMPORT_SAVE_RESULT:
            return { ...state, loading: false, importResult: action.payload };

        case DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO:
            return { ...state, loading: true, calampDevices: null };

        case DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO_RESULT:
            return { ...state, loading: false, calampDevices: action.payload };

        case DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV:
            return { ...state, loading: true, fileResponse: null };

        case DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV_RESULT:
            return { ...state, loading: false, fileResponse: action.payload, };

        case DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO:
            return { ...state, loading: true, geometrisDevices: null };

        case DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO_RESULT:
            return { ...state, loading: false, geometrisDevices: action.payload };

        case CLEAR_REDUX:
            return ["", "IMPORT_DEVICES"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};